/* ============================================================
   RESONANCE MARIN — Front-end Behaviour
   ------------------------------------------------------------
   Nav dropdowns, FAQ accordion, protocol step expand,
   homepage modal system, Boulevard booking integration,
   page-aware sticky bar.
   ============================================================ */

(function() {
  'use strict';

  /* ──────────────────────────────────────────────────────────
     ENHANCEMENT TABS — Click to switch panels
     ────────────────────────────────────────────────────────── */
  function initEnhancementTabs() {
    var sections = document.querySelectorAll('.rm-enhancements');
    sections.forEach(function(section) {
      var tabs = section.querySelectorAll('.rm-enh-tab');
      var panels = section.querySelectorAll('.rm-enh-panel');
      var select = section.querySelector('[data-enh-select]');

      function activate(target) {
        tabs.forEach(function(t) {
          var isActive = t.getAttribute('data-enh-tab') === target;
          t.classList.toggle('active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });
        panels.forEach(function(p) {
          p.classList.toggle('active', p.getAttribute('data-enh-panel') === target);
        });
        if (select && select.value !== target) {
          select.value = target;
        }
      }

      tabs.forEach(function(tab) {
        tab.addEventListener('click', function() {
          activate(tab.getAttribute('data-enh-tab'));
        });
      });

      if (select) {
        select.addEventListener('change', function() {
          activate(select.value);
        });
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     MOBILE MENU TOGGLE
     ────────────────────────────────────────────────────────── */
  function initMobileMenu() {
    var toggle = document.querySelector('.rm-nav-toggle');
    var menu = document.querySelector('.rm-mobile-menu');
    if (!toggle || !menu) return;

    function openMobile() {
      menu.classList.add('open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
      toggle.setAttribute('aria-label', 'Close menu');
      document.body.classList.add('rm-no-scroll');
    }
    function closeMobile() {
      menu.classList.remove('open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', 'Open menu');
      document.body.classList.remove('rm-no-scroll');
    }

    toggle.addEventListener('click', function() {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeMobile();
      } else {
        openMobile();
      }
    });

    menu.querySelectorAll('a').forEach(function(link) {
      link.addEventListener('click', function() {
        setTimeout(closeMobile, 50);
      });
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && menu.classList.contains('open')) {
        closeMobile();
      }
    });

    var resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > 900 && menu.classList.contains('open')) {
          closeMobile();
        }
      }, 200);
    });
  }

  /* ──────────────────────────────────────────────────────────
     NAV DROPDOWNS
     ────────────────────────────────────────────────────────── */
  function initNavDropdowns() {
    var navItems = document.querySelectorAll('.rm-nav-center > li > a');
    navItems.forEach(function(link) {
      link.addEventListener('click', function(e) {
        var li = link.parentElement;
        var hasDropdown = li.querySelector('.rm-drop');
        if (!hasDropdown) return;

        var wasOpen = li.classList.contains('open');

        document.querySelectorAll('.rm-nav-center > li').forEach(function(item) {
          item.classList.remove('open');
        });

        if (!wasOpen) {
          e.preventDefault();
          li.classList.add('open');
        }
      });
    });

    document.addEventListener('click', function(e) {
      if (!e.target.closest('.rm-nav')) {
        document.querySelectorAll('.rm-nav-center > li').forEach(function(item) {
          item.classList.remove('open');
        });
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     FAQ ACCORDION
     ────────────────────────────────────────────────────────── */
  function initFaqAccordion() {
    var faqItems = document.querySelectorAll('.rm-tx-faq-item');
    faqItems.forEach(function(item) {
      var q = item.querySelector('.rm-tx-faq-q');
      if (!q) return;
      q.addEventListener('click', function() {
        item.classList.toggle('expanded');
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     PROTOCOL STEP EXPAND
     ────────────────────────────────────────────────────────── */
  function initProtocolSteps() {
    var steps = document.querySelectorAll('.rm-tx-step');
    steps.forEach(function(step) {
      step.addEventListener('click', function() {
        steps.forEach(function(s) {
          if (s !== step) s.classList.remove('expanded');
        });
        step.classList.toggle('expanded');
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     HOMEPAGE TREATMENT MODAL
     ────────────────────────────────────────────────────────── */
  function initTxModals() {
    function openModal(id) {
      var overlay = document.getElementById('rm-modal-' + id);
      if (!overlay) return false;
      overlay.classList.add('open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      var panel = overlay.querySelector('.rm-modal');
      if (panel) panel.scrollTop = 0;
      return true;
    }

    function closeModal(overlay) {
      overlay.classList.remove('open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }

    document.addEventListener('click', function(e) {
      var trigger = e.target.closest('[data-tx-modal]');
      if (!trigger) return;
      var id = trigger.getAttribute('data-tx-modal');
      if (!id) return;
      if (document.getElementById('rm-modal-' + id)) {
        e.preventDefault();
        openModal(id);
      }
    });

    document.addEventListener('click', function(e) {
      var closeBtn = e.target.closest('.rm-modal-close');
      if (closeBtn) {
        var ov = closeBtn.closest('.rm-modal-overlay');
        if (ov) closeModal(ov);
        return;
      }
      if (e.target.classList && e.target.classList.contains('rm-modal-overlay')) {
        closeModal(e.target);
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        var open = document.querySelector('.rm-modal-overlay.open');
        if (open) closeModal(open);
      }
    });
  }

  /* ──────────────────────────────────────────────────────────
     BOULEVARD BOOKING INTEGRATION
     ------------------------------------------------------------
     Every booking CTA carries either:
       data-blvd-path="..."           — direct path override (preferred)
       data-booking-service="<slug>"  — slug to look up in BLVD_SERVICE_MAP

     If both present, data-blvd-path wins. This lets you fix a
     broken deep-link from the customizer (paste a fresh path from
     Boulevard's Sharing Options) without waiting for a code deploy.

     To add or update a service in the map:
       1. Boulevard → Manage Location → Services → [service]
          → Sharing Options → "Website link to this service"
       2. Copy the path value from the onclick snippet
       3. Add/update the entry below

     IMPORTANT: If a Boulevard service has no bookable staff
     assigned, deep-linking silently falls back to the general
     menu. This is a Boulevard data state, not a code issue.

     Boulevard categories (for reference):
       ESSENTIAL RESET FACIALS - 30 minutes
       CLINICAL-LUXE FACIALS - 60 minutes
       MASTERWORK FACIALS - 90 minutes
       ADVANCED RF MICRONEEDLING TREATMENTS
       MASSAGE - 60 minutes
       MASSAGE - 90 minutes
       SHIFT BODYWORK - 30 minutes
       BODY CARE
       SHOCK WAVE THERAPY
       RESTORE RITUALS  ← renamed from QUIET MIND RITUALS
       INFRARED SAUNA
     ────────────────────────────────────────────────────────── */
  var BLVD_SERVICE_MAP = {

    /* ── Facials ──────────────────────────────────────────── */
    'foundational-30':      '/cart/menu/ESSENTIAL%20RESET%20FACIALS%20-%2030%20minutes',
    'foundational-60':      '/cart/menu/CLINICAL-LUXE%20FACIALS%20-%2060%20minutes',
    'foundational-90':      '/cart/menu/MASTERWORK%20FACIALS%20-%2090%20minutes/s_48ff6308-3525-47d0-a2c9-dae9afd76ce9',
    'no-tox':               '/cart/menu/CLINICAL-LUXE%20FACIALS%20-%2060%20minutes/s_893557e9-9ab1-48d0-b5f4-5f2c0ce9b9eb',
    'rf-microneedling':     '/cart/menu/ADVANCED%20RF%20MICRONEEDLING%20TREATMENTS',
    'all-facials':          '/cart/menu/CLINICAL-LUXE%20FACIALS%20-%2060%20minutes',
    'all-foundational':     '/cart/menu/ESSENTIAL%20RESET%20FACIALS%20-%2030%20minutes',

    /* ── Massage — 60 min ────────────────────────────────── */
    'deep-relief-60':       '/cart/menu/MASSAGE%20-%2060%20minutes/s_9b1e9da4-c01f-4957-9819-567fd2a3260d',
    'swedish-60':           '/cart/menu/MASSAGE%20-%2060%20minutes/s_357bb7cb-eda9-4f49-b6fa-6ca74e952eb5',
    'lymphatic-flow-60':    '/cart/menu/MASSAGE%20-%2060%20minutes/s_3323739d-3cb4-40a1-bc85-85eb5600cefc',
    'fusion-60':            '/cart/menu/MASSAGE%20-%2060%20minutes/s_4840c104-00be-4c5c-8b3c-059cfb1ae0f0',
    'prenatal-60':          '/cart/menu/MASSAGE%20-%2060%20minutes/s_d9e8c37d-d0d2-4a07-a0b6-5e2b3864c5d3',

    /* ── Massage — 90 min ────────────────────────────────── */
    'deep-relief-90':       '/cart/menu/MASSAGE%20-%2090%20minutes/s_4e8bbd7b-bf33-4ad6-b5a3-88c75330cc64',
    'swedish-90':           '/cart/menu/MASSAGE%20-%2090%20minutes/s_47b1983a-cf7b-412b-a101-9c2c57fe6923',
    'lymphatic-flow-90':    '/cart/menu/MASSAGE%20-%2090%20minutes/s_bc3c4f7e-ba3b-4272-a7db-7f37c4b9d024',
    'fusion-90':            '/cart/menu/MASSAGE%20-%2090%20minutes/s_ab099b6a-be5a-437d-97a1-fa9db381bef9',
    'prenatal-90':          '/cart/menu/MASSAGE%20-%2090%20minutes/s_7d406dad-a25d-421a-bda2-75d16616a509',

    /* ── Shift Bodywork — 30 min ─────────────────────────── */
    'decompressor':         '/cart/menu/SHIFT%20BODYWORK%20-%2030%20minutes/s_cf94c64a-8b14-47ae-9e6d-2f6fccf8549f',
    'lymphatic-flow-30':    '/cart/menu/SHIFT%20BODYWORK%20-%2030%20minutes/s_6f08e989-ef9d-41ac-937f-b20e23bafe59',
    'ground-reset':         '/cart/menu/SHIFT%20BODYWORK%20-%2030%20minutes/s_35709976-245b-4d18-ab32-f71515c226d1',
    'upper-reset':          '/cart/menu/SHIFT%20BODYWORK%20-%2030%20minutes/s_6f08e989-ef9d-41ac-937f-b20e23bafe59',
    'cupping-therapy':      '/cart/menu/SHIFT%20BODYWORK%20-%2030%20minutes/s_cc201ad5-d146-4456-a70a-c57a7718b71b',

    /* ── Body Care ────────────────────────────────────────── */
    'body-care-ritual':     '/cart/menu/BODY%20CARE/s_70502a9a-43cc-41ec-96c3-bed9995c8a5b',

    /* ── Shockwave ────────────────────────────────────────── */
    'shockwave-eswt':       '/cart/menu/SHOCK%20WAVE%20THERAPY',
    'shockwave':            '/cart/menu/SHOCK%20WAVE%20THERAPY',

    /* ── Restore Rituals ─────────────────────────────────────
       Currently paused — services have no bookable staff.
       Booking CTAs on Restore pages route to the waitlist via
       RESTORE_PAUSED_SLUGS below.
       ────────────────────────────────────────────────────── */
    'restore-60':                 '/cart/menu/RESTORE%20RITUALS/s_9cdaf13a-022b-4437-80be-4c1d45051f46',
    'reflexology-restore-ritual': '/cart/menu/RESTORE%20RITUALS/s_032c12a9-f970-43f6-8a9e-1f24d84cac72',
    'lymphatic-restore-ritual':   '/cart/menu/RESTORE%20RITUALS/s_5b20bab3-7c76-4d1a-a0ec-7979e84513b3',

    /* Legacy aliases — kept so any old saved JSON values still resolve */
    'reflexology-restore':        '/cart/menu/RESTORE%20RITUALS/s_032c12a9-f970-43f6-8a9e-1f24d84cac72',
    'lymphatic-ritual':           '/cart/menu/RESTORE%20RITUALS/s_5b20bab3-7c76-4d1a-a0ec-7979e84513b3',

    /* ── Sauna ────────────────────────────────────────────── */
    'sauna-single-20':      '/cart/menu/INFRARED%20SAUNA/s_8d839474-e337-47fa-9165-19a7b293dd0f',
    'sauna-single-45':      '/cart/menu/INFRARED%20SAUNA/s_c848d0f0-62a2-46b3-969b-d2cdff53e09a',
    'sauna-double-20':      '/cart/menu/INFRARED%20SAUNA/s_8de8dad5-775e-4eec-b7cd-8a15842bfce3',
    'sauna-double-45':      '/cart/menu/INFRARED%20SAUNA/s_1f1e8b90-8fbd-4f3f-a6a6-2ab15f0c276e',

    /* ── Sauna Series (packages) ──────────────────────────────
       These are placeholders. Each series button has a customizer
       field for the actual path with visitType=PACKAGE. The values
       below are the menu category fallback only.
       ────────────────────────────────────────────────────── */
    'sauna-series':         '/cart/menu/BUY%20SAUNA%20SERIES'
  };

  /* ── Restore services currently paused (no staff assigned) ──
     Buttons with these slugs route to the waitlist instead of
     opening the Boulevard overlay. Update this list when staff
     are trained and services become bookable again.
     ────────────────────────────────────────────────────────── */
  var RESTORE_PAUSED_SLUGS = [
    'restore-60',
    'reflexology-restore',
    'reflexology-restore-ritual',
    'lymphatic-ritual',
    'lymphatic-restore-ritual'
  ];
  var WAITLIST_URL = '/pages/restore-waitlist';

  /* ── Resolve a button's deep-link path ──────────────────────
     1. If the button has data-blvd-path, use it directly.
     2. Otherwise look up the slug in BLVD_SERVICE_MAP.
     3. If neither, return null (caller falls back to general menu).
     ────────────────────────────────────────────────────────── */
  function resolvePath(btn) {
    if (!btn) return null;

    var direct = btn.getAttribute('data-blvd-path');
    if (direct) return direct;

    var slug = btn.getAttribute('data-booking-service') ||
               btn.getAttribute('data-booking-category');
    if (!slug) return null;

    slug = slug.toLowerCase().replace(/\s+/g, '-');
    return BLVD_SERVICE_MAP[slug] || null;
  }

  /* ── Get the slug from a button (for paused-slug check) ────── */
  function resolveSlug(btn) {
    if (!btn) return null;
    var slug = btn.getAttribute('data-booking-service') ||
               btn.getAttribute('data-booking-category');
    if (!slug) return null;
    return slug.toLowerCase().replace(/\s+/g, '-');
  }

  /* ──────────────────────────────────────────────────────────
     PAGE-AWARE STICKY BAR
     ------------------------------------------------------------
     The sticky book bar has empty booking attributes by default.
     On treatment pages, we want clicking it to open Boulevard
     deep-linked to whatever service is on this page.

     We find the first booking button on the page (hero CTA) and
     copy its slug + optional path onto the sticky button. So if
     the page is Deep Relief, the sticky bar books Deep Relief.
     If the page has no booking buttons (homepage, about, journal),
     the sticky stays generic and opens the menu.
     ────────────────────────────────────────────────────────── */
  function initStickyPageAware() {
    var sticky = document.querySelector('.rm-sticky-book-btn');
    if (!sticky) return;

    /* Find the first booking button that isn't the sticky itself */
    var allButtons = document.querySelectorAll('[data-booking-service], [data-blvd-path]');
    var hero = null;
    for (var i = 0; i < allButtons.length; i++) {
      var btn = allButtons[i];
      if (btn === sticky) continue;
      if (btn.closest('.rm-sticky-book')) continue;
      if (btn.closest('.rm-nav')) continue;
      if (btn.closest('.rm-mobile-menu')) continue;
      /* The button must actually carry a non-empty slug or path */
      var hasSlug = btn.getAttribute('data-booking-service') ||
                    btn.getAttribute('data-booking-category') ||
                    btn.getAttribute('data-blvd-path');
      if (hasSlug) { hero = btn; break; }
    }

    if (!hero) return;

    /* Copy slug + path onto the sticky button */
    var heroSlug = hero.getAttribute('data-booking-service');
    var heroCat = hero.getAttribute('data-booking-category');
    var heroPath = hero.getAttribute('data-blvd-path');

    if (heroSlug) sticky.setAttribute('data-booking-service', heroSlug);
    if (heroCat) sticky.setAttribute('data-booking-category', heroCat);
    if (heroPath) sticky.setAttribute('data-blvd-path', heroPath);
  }

  function initBoulevardBooking() {
    var locationId = window.RESONANCE_BLVD_LOCATION
      || 'cd701f1d-14d5-42e2-a868-62e083cbe152';

    function destroyOverlay() {
      var stale = document.querySelectorAll('.blvd-backdrop');
      stale.forEach(function(el) { el.remove(); });
    }

    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-booking-service], [data-booking-category], [data-blvd-path]');
      if (!btn) return;

      e.preventDefault();

      /* ── Restore paused → route to waitlist ────────────── */
      var slug = resolveSlug(btn);
      if (slug && RESTORE_PAUSED_SLUGS.indexOf(slug) !== -1) {
        window.location.href = WAITLIST_URL;
        return;
      }

      /* ── SDK available → open overlay ────────────────────── */
      if (window.blvd && typeof window.blvd.openBookingWidget === 'function') {
        var path = resolvePath(btn);
        var visitType = btn.getAttribute('data-blvd-visit-type') || 'SELF_VISIT';
        destroyOverlay();
        window.blvd.openBookingWidget({
          urlParams: {
            locationId: locationId,
            path: path || '/cart/menu',
            visitType: visitType
          }
        });
        return;
      }

      /* ── SDK not loaded → fallback ─────────────────────── */
      var fallbackUrl = window.RESONANCE_BOOKING_URL || '#book-now';
      window.location.href = fallbackUrl;
    });

    /* ── Intercept nav /#book-now links ─────────────────── */
    document.addEventListener('click', function(e) {
      var link = e.target.closest('a[href*="#book-now"]');
      if (!link) return;

      if (window.blvd && typeof window.blvd.openBookingWidget === 'function') {
        e.preventDefault();
        e.stopImmediatePropagation();
        destroyOverlay();
        window.blvd.openBookingWidget({
          urlParams: {
            locationId: locationId,
            path: '/cart/menu',
            visitType: 'SELF_VISIT'
          }
        });
      }
    }, true);
  }

  /* ──────────────────────────────────────────────────────────
     STICKY BAR — HIDE ON FOOTER VIEW
     ────────────────────────────────────────────────────────── */
  function initStickyBookVisibility() {
    var stickyBar = document.querySelector('.rm-sticky-book');
    var footer = document.querySelector('.rm-footer');
    if (!stickyBar || !footer) return;

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            stickyBar.style.opacity = '0';
            stickyBar.style.pointerEvents = 'none';
          } else {
            stickyBar.style.opacity = '1';
            stickyBar.style.pointerEvents = 'auto';
          }
        });
      }, { threshold: 0.1 });
      observer.observe(footer);
    }
  }

  /* ──────────────────────────────────────────────────────────
     ANCHOR NAV — Active state on scroll
     ────────────────────────────────────────────────────────── */
  function initAnchorNav() {
    var links = document.querySelectorAll('[data-anchor-link]');
    if (links.length === 0) return;

    var entries = [];
    links.forEach(function(link) {
      var hash = link.getAttribute('href');
      if (!hash || hash.indexOf('#') !== 0) return;
      var id = hash.slice(1);
      var el = document.getElementById(id);
      if (el) entries.push({ link: link, id: id, el: el });
    });
    if (entries.length === 0) return;

    function updateActive() {
      var scrollPos = window.scrollY + 200;
      var activeId = entries[0].id;
      entries.forEach(function(e) {
        if (e.el.offsetTop <= scrollPos) activeId = e.id;
      });
      entries.forEach(function(e) {
        e.link.classList.toggle('active', e.id === activeId);
      });
    }

    var ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateActive();
          ticking = false;
        });
        ticking = true;
      }
    });
    updateActive();
  }

  /* ──────────────────────────────────────────────────────────
     ANCHOR NAV — Mobile horizontal scroll edge fades
     ────────────────────────────────────────────────────────── */
  function initAnchorNavFades() {
    var navs = document.querySelectorAll('.rm-anchor-nav');
    navs.forEach(function(nav) {
      var scroller = nav.querySelector('[data-anchor-nav-scroller]');
      if (!scroller) return;

      function update() {
        var hasOverflow = scroller.scrollWidth > scroller.clientWidth;
        if (!hasOverflow) {
          nav.classList.remove('scrolled-start', 'scrolled-end');
          return;
        }
        var scrollLeft = scroller.scrollLeft;
        var maxScroll = scroller.scrollWidth - scroller.clientWidth;
        nav.classList.toggle('scrolled-start', scrollLeft > 4);
        nav.classList.toggle('scrolled-end', scrollLeft >= maxScroll - 4);
      }

      var ticking = false;
      scroller.addEventListener('scroll', function() {
        if (!ticking) {
          requestAnimationFrame(function() {
            update();
            ticking = false;
          });
          ticking = true;
        }
      });
      window.addEventListener('resize', update);
      update();
    });
  }

  /* ──────────────────────────────────────────────────────────
     RM-TX-ADDONS — click-to-expand for category groups
     ────────────────────────────────────────────────────────── */
  function initTxAddons() {
    var groups = document.querySelectorAll('.rm-tx-addons-group');
    if (!groups.length) return;

    groups.forEach(function(group) {
      var head = group.querySelector('.rm-tx-addons-head-row');
      if (!head) return;
      head.addEventListener('click', function() {
        var open = group.classList.toggle('expanded');
        head.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      head.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          head.click();
        }
      });
    });
  }

  /* ──────────────────────────────────────────────────────────
     INIT ON DOM READY
     ────────────────────────────────────────────────────────── */
  function init() {
    initNavDropdowns();
    initMobileMenu();
    initFaqAccordion();
    initProtocolSteps();
    initTxModals();
    initStickyPageAware();   /* Must run before initBoulevardBooking */
    initBoulevardBooking();
    initStickyBookVisibility();
    initEnhancementTabs();
    initAnchorNav();
    initAnchorNavFades();
    initTxAddons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
